import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./commonComponents/Layout/Layout";
import HomePage from "./pages/HomePage/HomePage";
import { createTheme, CssBaseline, ThemeProvider } from "@mui/material";
import ContactUs from "./pages/ContactUs/ContactUs";
import Services from "./pages/Services";
import About from "./pages/About";

const theme = createTheme({
  typography: {
    fontFamily: "Suisse Intl Regular, sans-serif",
  },
  palette: {
    primary: {
      main: "#164B7C",
    },
    secondary: {
      main: "#164B7C",
    },
  },
});

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
          </Route>
        </Routes>
      </Router>
    </ThemeProvider>
  );
};

export default App;
